import React, { useContext } from 'react';
import { useNavigation } from '@react-navigation/native';
import { Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import StyledIcon from '../StyledIcon';
import { NotificationContext } from '../../contexts/notification/Store';

const NotificationButton: React.FC = () => {
    const navigation = useNavigation();

    const { notif_state } = useContext(NotificationContext)

    const gotoNotificationScreen = () => {
        navigation.navigate('Notification')
    }

    return <>
        {
            Platform.OS === 'android' &&
            notif_state?.notifications?.length 
                ? <TouchableOpacity style={styles.wrapper} onPress={gotoNotificationScreen}>
                    <Text style={styles.text}>{ notif_state?.notifications?.length }</Text>
                    <StyledIcon
                        iconName="bell-plus"
                        iconColor={Colors.whiteColor}
                        size={13}
                        iconOnly
                        iconLibrary='MaterialCommunityIcons'
                    />
                </TouchableOpacity>
                : null
        }
    </>
}

export default NotificationButton

const styles = StyleSheet.create({
    wrapper: {
        flexDirection: 'row',
        flexShrink: 1,
        justifyContent: 'space-between',
        alignItems: 'center',

        paddingHorizontal: 6,
        paddingVertical: 4,

        marginLeft: 4,

        borderRadius: 100,

        backgroundColor: Colors.midTintColor,
    },
    text: {
        ...FontStyles.size13,
        ...FontStyles.medium,
        ...FontStyles.lh15,
        ...FontStyles.white,

        marginRight: 6,
        marginTop: -2,
    },
    icon: {}
})